<template>
  <div class="wrapper">
    <div class="video-container" :key="componentKey">
      <div v-if="understandVideo">
        <iframe
          class="video"
          :src="understandVideo"
          frameborder="0"
          allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
      <div v-else-if="isProductVideo">
        <iframe
          class="video"
          :src="ProductVideo"
          frameborder="0"
          allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
      <div v-else-if="situation && situation.media">
        <iframe
          v-if="situation.media.url"
          class="video"
          :src="situation.media.url"
          frameborder="0"
          allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
        <video
          id="video"
          controls
          class="video"
          v-if="situation.media.filename && isMediaLoaded && isTherePreview"
          :poster="'/demo/video/preview/' + getPreview"
          preload="auto"
        >
          <source id="image" :src="'/demo/video/' + situation.media.filename" type="video/mp4" />
        </video>
        <video
          id="video"
          controls
          class="video"
          v-if="situation.media.filename && isMediaLoaded && !isTherePreview"
          preload="auto"
        >
          <source id="image" :src="'/demo/video/' + situation.media.filename" type="video/mp4" />
        </video>
        <div class="overlay">
          <span v-show="isVideoBlur" class="overlay-item glass-left"></span>
          <span v-show="isVideoBlur" class="overlay-item glass-right"></span>
          <span v-show="dashed" class="dashed-left"></span>
          <span v-show="dashed" class="dashed-right"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Video',
  data() {
    return {
      componentKey: 0,
      dashed: false,
    };
  },
  mounted() {
    this.dashed = this.isVideoBlur;
  },
  computed: {
    isVideoBlur() {
      if (this.currentSituation && this.currentSituation.media && this.currentSituation.media.type === 'videoBlur2') {
        return true;
      }
      return false;
    },
    situation() {
      return this.$store.getters.getSituationById(this.$route.params.idSituation)[0];
    },
    understandVideo() {
      if (this.$store.getters.isVideoLoaded()) {
        return this.$store.getters.getVideoLinkWithName(this.$route.params.nameVideo);
      }
      return null;
    },
    ProductVideo() {
      return `https://player.vimeo.com/video/${this.$route.params.youtubeId}`;
    },
    isProductVideo() {
      return !!this.$route.params.youtubeId;
    },
    getPreview() {
      return this.$store.getters.getMediaById('Demo-Image-Preview' + this.situation.media.filename.split('.').shift())
        .filename;
    },
    isTherePreview() {
      return this.$store.getters.getMediaById(
        'Demo-Image-Preview' + this.situation.media.filename.split('.').shift()
      ) == null
        ? false
        : true;
    },
    isMediaLoaded() {
      return this.$store.getters.isMediasLoaded();
    },
  },
  methods: {
    forceRerender() {
      this.componentKey += 1;
    },
  },
  watch: {
    '$route.params.idSituation': function() {
      //Force re render component
      this.forceRerender();
    },
  },
};
</script>

<style scoped>
.wrapper {
  width: 100%;
  height: 100%;
}
.video-container {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
}
.ytp-title-channel {
  display: none;
}
iframe.video {
  position: absolute;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  margin: auto;
}
video.video {
  position: absolute;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  margin: auto;
}

.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
}
.glass-left,
.glass-right {
  bottom: 0;
  width: 40%;
  height: 60%;
  position: absolute;
  mask: radial-gradient(farthest-side at center, black 70%, transparent 80%);
  backdrop-filter: blur(4px);
  pointer-events: none;
}
.glass-left {
  left: 0;
}
.glass-right {
  right: 0;
}

.dashed-left,
.dashed-right {
  width: 40%;
  height: 60%;
  position: absolute;
  border: 4px dashed white;
  bottom: 0;
  border-radius: 50%;
  opacity: 0.4;
}
.dashed-left {
  left: 0;
}
.dashed-right {
  right: 0;
}
</style>
